import React from 'react';
import { connect } from 'react-redux';
import Tips from '../../../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { getSafe } from '@/helpers/global';
import { utilsFunction } from '@/helpers/functions'
import { SERVICES_RESP as servicesResp } from '@/configurations';
import { dataType as types } from '@/constants/data-type';
import { formatFunctions } from '@/helpers/functions';
import { IPO_MODE } from '@/constants/app';

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      amountPrice: '',
      currencyID: ''
    }
  }

  componentDidUpdate(preProps) {
    if (preProps.resultResp && this.props.resultResp !== preProps.resultResp) {
      this.setResultStatus()
    }
  }

  componentDidMount() {
    this.setResultStatus()
  }

  setResultStatus() {
    if (this.props.resultResp.errorCode === servicesResp.SUCCESS_CODE) {
      let amount = this.props.resultData.find(item => item.label === 'common_subscription_amount').value.split(',').join('') * 1000
      let fee = this.props.resultData.find(item => item.label === 'ipo_service_charge').value * 1000
      let currencyID = this.props.resultData.find(item => item.label === 'common_currency').value
      let facilityFee = this.props.resultData.find(item => item.label === 'ipo_facility_fee') ? this.props.resultData.find(item => item.label === 'ipo_facility_fee').value * 1000 :0;
      this.setState({
        amountPrice: (amount + fee + facilityFee) / 1000,
        currencyID: currencyID,
        status: true
      })
    } else {
      this.setState({
        status: false
      })
    }
  }



  render() {
    const { language, resultResp, resultData, load, mode,marginResultData } = this.props;
    const { status, amountPrice, currencyID } = this.state;
    return (
      <React.Fragment>
        <div className='preview-container'>
          <section className="table">
            {
              !load && <Tips type={status ? tipsType.success : tipsType.error} isNoBgColor style={{ margin: '0 0 16px -17px', fontSize: '20px' }}>
                {status ? getSafe(() => language.ipo_apply_successfully_applied) : getSafe(() => resultResp.errorMessage)}
              </Tips>
            }

            {
              status && 
              <React.Fragment>
                <div className="resultOneTips">
                  <div>{getSafe(() => language.ipo_result_head_message_one)}</div>
                  <div>{getSafe(() => language.common_date)} : {resultResp.inputTime}</div>
                  <div>{getSafe(() => language.ipo_result_head_message_two)}<b style={{color:'#0066B3'}}>{resultResp.subscriptionID}</b></div>
                </div>
                <div className="resultTwoTips">
                  <div>{getSafe(() => language.ipo_result_head_message_three)}</div>
                  <div>{getSafe(() => language.ipo_result_head_message_four)}</div>
                </div>
                <div className="resultThreeTips">
                  {getSafe(() => language.ipo_result_head_message_five)}
                </div>
              </React.Fragment>
            }

            <ul>
              {
                resultData.map((item, index) =>
                item.label && <li key={index}>
                    <div className="left">{getSafe(() => language[item.label])}</div>
                    <div className="right">{item.value}</div>
                  </li>
                )
              }
              {
                mode === IPO_MODE.MARGIN_APPLY_ACTION  && marginResultData.map((item, index) =>
                item.label && <li key={index + 13}>
                  <div className="left">{getSafe(() => language[item.label])}</div>
                  <div className="right">{item.value}</div>
                </li>
              )
              }
            </ul>
            <div className="total-amount-price">
              {getSafe(() => language.common_total_amount_of_payment)}: <span className="price">{utilsFunction.formatNumber(amountPrice, 2)} {currencyID}</span>
            </div>
          </section>
        </div>
      </React.Fragment>
    )
  }
}
export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(Result)
